/** Shop PLP */
export const FETCH_SHOP_CATALOG_REQUEST = 'product/FETCH_SHOP_CATALOG_REQUEST';
export const FETCH_SHOP_CATALOG_SUCCESS = 'product/FETCH_SHOP_CATALOG_SUCCESS';
export const FETCH_SHOP_CATALOG_FAILURE = 'product/FETCH_SHOP_CATALOG_FAILURE';

/** PDP */
export const FETCH_PRODUCT_DETAIL_REQUEST = 'product/FETCH_PRODUCT_DETAIL_REQUEST';
export const FETCH_PRODUCT_DETAIL_SUCCESS = 'product/FETCH_PRODUCT_DETAIL_SUCCESS';
export const FETCH_PRODUCT_DETAIL_FAILURE = 'product/FETCH_PRODUCT_DETAIL_FAILURE';

/** Home rails — not shared with shop list */
export const FETCH_HOME_CATALOG_REQUEST = 'product/FETCH_HOME_CATALOG_REQUEST';
export const FETCH_HOME_CATALOG_SUCCESS = 'product/FETCH_HOME_CATALOG_SUCCESS';
export const FETCH_HOME_CATALOG_FAILURE = 'product/FETCH_HOME_CATALOG_FAILURE';

export const CLEAR_PRODUCT_DETAIL = 'product/CLEAR_PRODUCT_DETAIL';
